import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
// components
import { Button } from "../../../../UI/Button/Button";
import rocket from "../../../../assets/img/dashboard/rocket.png";
import dots from "../../../../assets/img/dashboard/dots.png";
import man from "../../../../assets/img/dashboard/man.png";
import planet from "../../../../assets/img/dashboard/planet.png";
import dotsRight from "../../../../assets/img/dashboard/dotsRight.png";
import bottom from "../../../../assets/img/dashboard/bottom.png";

// styles
import "./DashboardHeader.css";

export const DashboardHeader = ({
  handleConnect,
  handleGetStarted,
  account,
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <header
      className={`h-screen dashboard-header-container ${
        animate ? "animate" : ""
      }`}
    >
      <img src={rocket} className={"dashboard-header-rocket-img"} />
      <div className="dashboard-header">
        <img src={dots} className={"dashboard-header-dots-img"} />
        <div className={"dashboard-header-top"}>
          <h1>Pay</h1>
          <h1>Direct With</h1>
        </div>
        <div className={"dashboard-header-bottom"}>
          <h1>Crypto</h1>
          <p>The easiest way to implement crypto payments in your app.</p>
        </div>
        <img src={man} className={"dashboard-header-man-img"} />
        <img src={planet} className={"dashboard-header-planet-img"} />
      </div>
      <img src={dotsRight} className={"dashboard-header-dotsRight-img"} />
      <div className={"dashboard-buttons"}>
        {!account && (
          <Button
            label={"Connect Wallet"}
            size={"btn-lg"}
            type={"btn-primary"}
            arrow={"arrow-none"}
            element={"button"}
            onClick={() => {}}
            customStyles={{ margin: "0" }}
          />
        )}
        <a
          href="https://www.npmjs.com/package/@hypersokrat/hyper-pay"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleConnect}
        >
          <Button
            label={"Get Started"}
            size={"btn-lg"}
            type={"btn-secondary"}
            arrow={"arrow-none"}
            element={"button"}
            onClick={() => {}}
            customStyles={{ margin: "0" }}
          />
        </a>
      </div>
      <img src={bottom} className={"dashboard-header-bottom-img"} />
    </header>
  );
};
